module.exports = __webpack_public_path__ + "static/media/search.97ae91a4.svg";